import React from 'react';
import styled from 'styled-components';
import { getTranslatedString } from 'helpers/i18n';
import { colors } from 'helpers/ColorHelper';
import { media } from 'helpers/MediaHelper';

import { MdClose as CloseIcon } from 'react-icons/md';

const StyledDialog = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: ${colors.WIZARD_GREY};
  padding: 62px;
  display: flex;
  justify-content: unset;
  align-items: center;
  z-index: 1301; // the left-hand material blade has a z-index of 1300...
  overflow-y: ${(props) => (props.hideOverflow ? 'unset' : 'auto')};
  flex-direction: column;
  ${media.mobile`
    padding: 28px;
  `};
`;

const StyledCloseContainer = styled.div`
  position: absolute;
  top: 62px;
  right: 62px;
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: pointer;
  background: none;
  border: none;
  ${media.mobile`
    top: 28px;
    right: 28px;
  `};
`;

const StyledCloseIcon = styled(CloseIcon)`
  border: 1px solid white;
  font-size: 18px;
  background-color: white;
  border-radius: 50%;
  height: 20px;
`;

const StyledCloseText = styled.span`
  display: block;
  margin-top: 8px;
  color: ${colors.GRAY};
  ${media.mobile`
    display: none;
  `};
`;

const StyledChildrenContainer = styled.div`
  height: 100%;
  width: ${(props) => props.componentWidth || '100%'};
  margin-top: 80px;
  ${media.mobile`
    margin-top: 20px;
    width: 100%;
  `};
`;

const FullScreenDialog = ({
  children,
  visible,
  showClose = false,
  handleClose,
  componentWidth,
  hideOverflow,
}) => {
  return (
    visible && (
      <StyledDialog hideOverflow={hideOverflow}>
        <StyledChildrenContainer componentWidth={componentWidth}>
          {children}
        </StyledChildrenContainer>
        {showClose && (
          <StyledCloseContainer onClick={handleClose}>
            <StyledCloseIcon />
            <StyledCloseText>{getTranslatedString('close')}</StyledCloseText>
          </StyledCloseContainer>
        )}
      </StyledDialog>
    )
  );
};

export default FullScreenDialog;
